import type { InitMethodType } from '@onramp/components/AppManagerProvider/types';
import { atom } from 'jotai';

export const initMethodAtom = atom<InitMethodType | undefined>(undefined);

export const haveAppliedDefaultAssetAtom = atom(false);
